import { AppleGlyph, PlayGlyph } from "@/features/portal/components/platform-glyphs";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

/**
 * Where the mobile app is listed. Empty until it is published: a button then says "coming to"
 * and links nowhere, rather than sending somebody to a store page that does not exist.
 */
const STORE_LINKS = { appStore: "", googlePlay: "" };

const tones = {
  /** On the page or a photo. */
  light: "bg-foreground text-background",
  /** On a solid primary band. */
  ink: "bg-primary-foreground text-primary",
};

/** App Store and Google Play, side by side. */
export const StoreButtons = ({ tone = "light", className }: { tone?: keyof typeof tones; className?: string }) => (
  <div className={cn("flex flex-wrap gap-2", className)}>
    {[
      { id: "app-store", href: STORE_LINKS.appStore, glyph: <AppleGlyph />, name: m.portal_store_app_store() },
      { id: "google-play", href: STORE_LINKS.googlePlay, glyph: <PlayGlyph />, name: m.portal_store_google_play() },
    ].map((store) => {
      const body = (
        <>
          {store.glyph}
          <span className="leading-none">
            <small className="block text-[10px] font-medium opacity-70">
              {store.href ? m.portal_store_get() : m.portal_store_soon()}
            </small>
            <b className="mt-0.5 block text-sm font-semibold">{store.name}</b>
          </span>
        </>
      );
      const classes = cn("inline-flex h-[46px] items-center gap-2.5 rounded-full pr-[18px] pl-3.5", tones[tone]);
      return store.href ? (
        <a key={store.id} href={store.href} className={cn(classes, "transition-transform active:scale-[0.97]")}>
          {body}
        </a>
      ) : (
        <span key={store.id} className={classes}>
          {body}
        </span>
      );
    })}
  </div>
);
